module.exports = __webpack_public_path__ + "static/media/topup-success.d8237b50.svg";